import styled from 'astroturf/react'
import { now, parseWithFormat, diff } from '@calendly/datetime'
const textColorLevel2 = 'var(--text-color-level2, rgba(26, 26, 26, 0.61))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
const fontSizeSmall = 'var(--fontSizeSmall, 0.75rem)'

import { useI18n } from 'locales'
import _StyledSubtitle from "week_subtitle-StyledSubtitle.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/week_subtitle.js?styleId=StyledSubtitle";


const StyledSubtitle = /*#__PURE__*/styled('span', null, {
  displayName: "StyledSubtitle",
  styles: _StyledSubtitle
})

const WeekSubtitle = ({ weekStart }) => {
  const { i18n } = useI18n()
  const currentWeekStart = now().startOf('week', { useLocaleWeeks: true })
  const weekStartDate = parseWithFormat(weekStart, 'MM-dd-yyyy').startOf('week', { useLocaleWeeks: true })
  const weekDiff = Math.round(diff(weekStartDate, currentWeekStart, 'weeks'))

  return (
    <StyledSubtitle>
      {weekDiff === 0 && i18n.t('booking.calendar.week.this_week')}
      {weekDiff === 1 && i18n.t('booking.calendar.week.next_week')}
      {weekDiff > 1 && i18n.t('booking.calendar.week.other_week', { count: weekDiff })}
    </StyledSubtitle>
  )
}

export default WeekSubtitle
